import { NgModule } from '@angular/core'

import { FlxIconModule, provideExtraIconSet } from '@flowx/angular-ui-toolkit'

import {
  ICON_OUTCOME_ACTIVE,
  ICON_OUTCOME_DISABLED,
  ICON_OUTCOME_HIDDEN,
  ICON_OUTCOME_VISIBLE,
} from './constants/icons.constants'

export const OutputIcons = {
  'outcome-visible': ICON_OUTCOME_VISIBLE,
  'outcome-hidden': ICON_OUTCOME_HIDDEN,
  'outcome-active': ICON_OUTCOME_ACTIVE,
  'outcome-disabled': ICON_OUTCOME_DISABLED,
}

export const ScriptingIcons = {
  ...OutputIcons,
}

@NgModule({
  imports: [FlxIconModule],
  providers: [provideExtraIconSet(ScriptingIcons)],
  exports: [FlxIconModule],
})
export class ScriptingIconsModule {}
